import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import TabTitle from '../../../../components/tabTitle';
import CattleStocks from './cattleStocks';
import IndexNum from './indexNum';

class ScylTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        current: this.props.content.current,
    };

    handleMouseOver = index => {
        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { title, tabTits } = this.props.content;
        const { current } = this.state;
        const renderItem = index => {
            let Dom = null;

            switch (index) {
                case 0:
                    Dom = <CattleStocks isOpen={isOpen} />;
                    break;
                case 1:
                    Dom = <IndexNum />;
                    break;

                default:
                    break;
            }

            return Dom;
        };

        return (
            <div className={styles.tab}>
                <TabTitle title={title} tabTits={tabTits} current={current} callback={this.handleMouseOver} />
                <div style={{ display: Number(current) === 0 ? 'block' : 'none' }}>
                    <CattleStocks isOpen={isOpen} />
                </div>
                <div style={{ display: Number(current) === 1 ? 'block' : 'none' }}>
                    <IndexNum />
                </div>
            </div>
        );
    }
}

export default errorBoundary(ScylTable);
